import React from "react";
import BusinessGroup from "src/pages/Config/BusinessGroup";
import Sectors from "src/pages/Config/Sectors";
import Classifications from "src/pages/Config/Classification";
import process from "src/pages/Config/Process";
import MeasureUnits from "src/pages/Config/MeasureUnits";
import Metrics from "src/pages/Config/Metrics";
import PeriodTypes from "src/pages/Config/PeriodTypes"; 
import Tags from "src/pages/Config/Tags";
import CanvasModels from "src/pages/Config/CanvasModels";
import IntegrationTypes from "src/pages/Config/IntegrationTypes";
import DataOrigin from "src/pages/Config/DataOrigin";
import UsersPage from "src/pages/Config/Users";
import Business from "src/pages/Config/Business";
import UserGroup from "src/pages/Config/UserGroup";
import Permissions from "src/pages/Config/Permissions";
import Suggestions from "src/pages/Config/Suggestions";

import CommercialPlans from "src/pages/Config/CommercialPlans";
import ContractItems from "src/pages/Config/ContractItems";
import SystemConnections from "src/pages/Config/SystemConnections";
import Integrations from "src/pages/Config/Integrations";
import AccessIp from "src/pages/Config/AccessIP/index";

import ParametersGroup from "src/pages/Config/Parameters/config";
import ParametersHierarchy from "src/pages/Config/Parameters/Hierarchy";

import Notifications from "src/pages/Config/Notifications";
import ExternalAccessKeys from "src/pages/Config/ExternalAccessKeys";
import Terms from "src/pages/Config/TermsUse";
import MonitorContracts from "src/pages/Config/MonitorContracts";
import Incidents from "src/pages/Config/Incidents";
import Domains from "src/pages/Config/Domains";
import Coins from "src/pages/Config/Coins";
import RoutePrivate from "./private";

export default [
	<RoutePrivate path="/businessgroup" key="businessGroup" exact component={BusinessGroup} isPrivate />,
	<RoutePrivate path="/business" key="business" exact component={Business} isPrivate />,
	<RoutePrivate path="/sectors" key="sectors" exact component={Sectors} isPrivate />,
	<RoutePrivate path="/classifications" key="classifications" exact component={Classifications} isPrivate />,
	<RoutePrivate path="/process" key="process" exact component={process} isPrivate />,
	<RoutePrivate path="/measureunits" key="measureunits" exact component={MeasureUnits} isPrivate />,
	<RoutePrivate path="/periodtypes" key="periodtypes" exact component={PeriodTypes} isPrivate />,
	<RoutePrivate path="/canvasmodels" key="canvasModels" exact component={CanvasModels} isPrivate />,
	<RoutePrivate path="/tags" key="tags" exact component={Tags} isPrivate />,
	<RoutePrivate path="/tags/:tagId" permissionPath="/tags" key="tagstagId" exact component={Tags} isPrivate />,
	<RoutePrivate path="/metrics" key="metrics" exact component={Metrics} isPrivate />,
	<RoutePrivate path="/integrationtypes" key="integrationTypes" exact component={IntegrationTypes} isPrivate />,
	<RoutePrivate path="/dataorigin" key="dataOrigin" exact component={DataOrigin} isPrivate />,
	<RoutePrivate path="/users" key="users" exact component={UsersPage} isPrivate />,
	<RoutePrivate path="/contractitems" key="contractItems" exact component={ContractItems} isPrivate />,
	<RoutePrivate path="/monitorcontracts" key="monitorContracts" exact component={MonitorContracts} isPrivate />,
	<RoutePrivate path="/usergroup" key="userGroup" exact component={UserGroup} isPrivate />,
	<RoutePrivate path="/permissions" key="permissions" exact component={Permissions} isPrivate />,
	<RoutePrivate path="/commercialplans" key="commercialPlans" exact component={CommercialPlans} isPrivate />,
	<RoutePrivate path="/systemconnections" key="systemConnections" exact component={SystemConnections} isPrivate />,
	<RoutePrivate path="/parameters/groups" key="parametersGroups" exact component={ParametersGroup} isPrivate />,
	<RoutePrivate path="/parameters/hierarchy" key="parametersHierarchy" exact component={ParametersHierarchy} isPrivate />,
	<RoutePrivate path="/notifications" key="notifications" exact component={Notifications} isPrivate />,
	<RoutePrivate path="/integrations" key="integrations" exact component={Integrations} isPrivate />,
	<RoutePrivate path="/accessIp" key="accessIp" exact component={AccessIp} isPrivate />,
	<RoutePrivate path="/externalaccesskeys" key="externalAccessKeys" exact component={ExternalAccessKeys} isPrivate />,
	<RoutePrivate path="/incidents" key="incidents" exact component={Incidents} isPrivate />,
	<RoutePrivate path="/termsuse" key="terms" exact component={Terms} isPrivate/>,
	<RoutePrivate path="/suggestions" key="suggestions" exact component={Suggestions} isPrivate checkPermission={false} />,
	<RoutePrivate path="/domains" key="domains" exact component={Domains} isPrivate />,	
	<RoutePrivate path="/coins" key="coins" exact component={Coins} isPrivate/>
];
